/**
  * 系统功能模块接口列表
  */

import base from '../base'; // 导入接口域名列表
import axios from '../../request/http'; // 导入http中创建的axios实例

const sysFunctionApi = {
    GetDataTreeList: `${base.qa}/Module/GetDataTreeList`,
    GetDataByParentId: `${base.qa}/Module/GetDataByParentId`,
    GetDataById: `${base.qa}/Module/GetDataById`,
    SaveData: `${base.qa}/Module/SaveData`,
    DelData: `${base.qa}/Module/DelData`,
    GetDataList: `${base.qa}/ModuleButton/GetDataList`,
    SaveBtnData: `${base.qa}/ModuleButton/SaveData`,
    GetBtnDataById: `${base.qa}/ModuleButton/GetDataById`,
    DelBtnData: `${base.qa}/ModuleButton/DelData`,
}

const sysFunction = {
    GetDataTreeList () {
        return axios.get(sysFunctionApi.GetDataTreeList)
    },
    GetDataByParentId (parentid) {
        return axios.get(sysFunctionApi.GetDataByParentId, { params: { parentid } })
    },
    GetDataById (params) {
        return axios.get(sysFunctionApi.GetDataById, { params: { moduleid: params } })
    },
    SaveData (params) {
        return axios.post(sysFunctionApi.SaveData, params)
    },
    DelData (params) {
        return axios.post(sysFunctionApi.DelData, params)
    },
    GetDataList (moduleid) {
        return axios.get(sysFunctionApi.GetDataList, { params: { moduleid } })
    },
    SaveBtnData (params) {
        return axios.post(sysFunctionApi.SaveBtnData, params)
    },
    GetBtnDataById (modulebuttonid) {
        return axios.get(sysFunctionApi.GetBtnDataById, { params: { modulebuttonid } })
    },
    DelBtnData (params) {
        return axios.post(sysFunctionApi.DelBtnData, params)
    },
}


export default sysFunction;